import { Injectable } from '@angular/core';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {VehicleCondition} from '../../consts/vehicle-condition.enum';

@Injectable({
  providedIn: 'root'
})
export class OlxValuesMappingService {

  constructor() { }

  mapBrandName(olxBrandName: string): string {
    const mappingItem = BRANDS_MAPPING_DEFINITION.find(item => item.olxValue === olxBrandName);
    return mappingItem ? mappingItem.targetValue : olxBrandName;
  }

  mapFuelName(olxFuelName: string, items: any[]): string {
    const mappingItem = FUELS_MAPPING_DEFINITION.find(item => item.olxFuelName === olxFuelName);
    if (mappingItem) {
      let fuelItem = items.find(fItem => fItem.fuelName.toUpperCase() === mappingItem.targetKeyword);
      if (isNotNullOrUndefined(fuelItem)) {
        fuelItem = items.find(fItem => fItem.fuelName.toUpperCase().includes(mappingItem.targetKeyword));
      }
      return fuelItem ? fuelItem.fuelName : null;
    }
    return null;
  }

  mapVehicleCondition(olxVehicleCondition: string): string {
    switch (olxVehicleCondition) {
      case 'damaged': {
        return VehicleCondition.DAMAGED;
      }
      case 'notdamaged': {
        return VehicleCondition.NOT_DAMAGED;
      }
      default:
        return null;
    }
  }
}

export interface OlxValueMappingItem {
  olxValue: string;
  targetValue: string;
}

export interface OlxFuelMappingItem {
  olxFuelName: string;
  targetKeyword: string;
}

const BRANDS_MAPPING_DEFINITION: OlxValueMappingItem[] = [
  { olxValue: 'aixam', targetValue: null },
  { olxValue: 'alfa-romeo', targetValue: 'ALFA ROMEO' },
  { olxValue: 'landrover', targetValue: 'LAND ROVER' },
  { olxValue: 'mini', targetValue: 'MINI [BMW]' },
  { olxValue: 'polonez', targetValue: null },
  { olxValue: 'pozostale', targetValue: null },
  { olxValue: 'ssangyong', targetValue: 'SSANG YONG' },
];

const FUELS_MAPPING_DEFINITION: OlxFuelMappingItem[] = [
  { olxFuelName: 'petrol', targetKeyword: 'BENZYNA' },
  { olxFuelName: 'cng', targetKeyword: 'GAZ' },
  { olxFuelName: 'diesel', targetKeyword: 'DIESEL' },
  { olxFuelName: 'electric', targetKeyword: 'ELEKTRYCZNY' },
  { olxFuelName: 'lpg', targetKeyword: 'GAZ' },
];
